// import Switch from 'react-ios-switch';
import Slider from "@mui/material/Slider";
import React, { useState } from "react";
import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { setQuality } from "../../Redux/DownloadSlice/downloadSlice";

import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
const ImageQuality = ({ downloadState }) => {
  const [size, setSize] = useState(90);
  const { t } = useTranslation();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setQuality(size));
  }, [size]);
  useEffect(() => {
    if (downloadState.Found) setSize(downloadState.Quality);
    else setSize(90);
  }, []);
  return (
    <Card className="bg_grey">
      <Card.Header>
        <Row className="p-1 productSans text_15 d-flex justify-content-start align-items-center">
          {t("DownloadImage.Quality")}
        </Row>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col
            md={10}
            className="p-1 pe-4 d-flex justify-content-center align-items-center"
          >
            <Slider
              className="slider"
              aria-label="Small"
              size="small"
              value={size}
              step={1}
              min={10}
              max={100}
              onChange={(e, value) => setSize(value)}
            />
          </Col>
          <Col className="Aktiv text_16 p-0 d-flex justify-content-center align-items-center">
            {parseInt(size) + "%"}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ImageQuality;
